import { useState, useEffect } from 'react';
import axios from 'axios';
import { Bell, LogOut, ChevronDown } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const TopBar = ({ user, onLogout }) => {
  const [claimants, setClaimants] = useState([]);
  const [selectedClaimant, setSelectedClaimant] = useState('');

  useEffect(() => {
    if (user?.role === 'admin') {
      fetchClaimants();
    }
  }, [user]);

  const fetchClaimants = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/admin/claimants`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClaimants(res.data.claimants);
    } catch (err) {
      console.error('Failed to fetch claimants:', err);
    }
  };

  return (
    <div style={{
      height: '70px',
      background: 'white',
      borderBottom: '1px solid #e2e8f0',
      padding: '0 2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div style={{ flex: 1 }} />
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
        {/* Claimant Selector (Admin only) */}
        {user?.role === 'admin' && claimants.length > 0 && (
          <div className="form-group" style={{ margin: 0, minWidth: '200px' }}>
            <select
              data-testid="claimant-selector"
              className="form-select"
              value={selectedClaimant}
              onChange={(e) => setSelectedClaimant(e.target.value)}
              style={{ padding: '0.5rem 1rem', fontSize: '0.875rem' }}
            >
              <option value="">All Claimants</option>
              {claimants.map((c) => (
                <option key={c._id} value={c._id}>{c.name}</option>
              ))}
            </select>
          </div>
        )}


        {/* User Details */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          padding: '0.5rem 1rem',
          background: '#f7fafc',
          borderRadius: '8px'
        }}>
          <div style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: '#667eea',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: '0.875rem'
          }}>
            {user?.name?.charAt(0) || 'U'}
          </div>
          <div>
            <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#2d3748' }}>
              {user?.name || user?.phone}
            </div>
            <div style={{ fontSize: '0.75rem', color: '#718096' }}>
              {user?.role?.replace('_', ' ').toUpperCase()}
            </div>
          </div>
        </div>

        {/* Logout Button */}
        <button
          data-testid="topbar-logout"
          onClick={onLogout}
          style={{
            padding: '0.5rem 1rem',
            background: '#fc8181',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '0.875rem',
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#f56565'}
          onMouseLeave={(e) => e.currentTarget.style.background = '#fc8181'}
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default TopBar;
